import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraDataTable } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraLink } from '@mono/ui-components/ensigns';
import { SpecraEntityCell, SpecraUnverifiedClaim } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { carriedInStatusVariant } from '../proposalBadgeVariants';
const ids = Testids.proposalCarriedIn;
function RowLink({ href, label }) {
    if (!label) return null;
    if (!href) return /*#__PURE__*/ _jsx(_Fragment, {
        children: label
    });
    return /*#__PURE__*/ _jsx(SpecraLink, {
        href: href,
        renderLink: renderRouterLink,
        children: label
    });
}
// Black-hat items are display-only hearsay: framed, linked back to the source, never insertable.
function ItemLine({ row, item }) {
    const title = item.href ? /*#__PURE__*/ _jsx(SpecraLink, {
        href: item.href,
        renderLink: renderRouterLink,
        children: item.title
    }) : item.title;
    if (row.kind === 'black_hat') {
        return /*#__PURE__*/ _jsx("li", {
            "data-testid": ids.item,
            children: /*#__PURE__*/ _jsx(SpecraUnverifiedClaim, {
                claim: title,
                kindLabel: "Hearsay · not citable"
            })
        });
    }
    return /*#__PURE__*/ _jsx("li", {
        "data-testid": ids.item,
        children: title
    });
}
// specra-allow local-composite: the spec-mandated shared table for Home (PRP-07) and the Sources page; it only binds CarriedInRow columns to SpecraDataTable
export function CarriedInTable({ rows, expanded = false }) {
    return /*#__PURE__*/ _jsx(SpecraDataTable, {
        caption: "Carried in from the pursuit",
        testId: ids.table,
        rows: rows,
        getRowId: (r)=>r.kind,
        rowTestId: (r)=>`${ids.row}-${r.kind}`,
        columns: [
            {
                id: 'what',
                header: 'What',
                cell: (r)=>/*#__PURE__*/ _jsxs("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraEntityCell, {
                                title: r.title,
                                description: r.summary || undefined
                            }),
                            expanded && r.items.length > 0 ? /*#__PURE__*/ _jsx("ul", {
                                className: "space-y-1 pl-3 text-sm",
                                children: r.items.map((item)=>/*#__PURE__*/ _jsx(ItemLine, {
                                        row: r,
                                        item: item
                                    }, item.id))
                            }) : null
                        ]
                    })
            },
            {
                id: 'from',
                header: 'From',
                cell: (r)=>/*#__PURE__*/ _jsx(RowLink, {
                        href: r.fromHref,
                        label: r.fromLabel
                    })
            },
            {
                id: 'lands',
                header: 'Where it lands',
                cell: (r)=>/*#__PURE__*/ _jsx(RowLink, {
                        href: r.landsHref,
                        label: r.landsLabel
                    })
            },
            {
                id: 'status',
                header: 'Status',
                cell: (r)=>/*#__PURE__*/ _jsx(SpecraBadge, {
                        variant: carriedInStatusVariant[r.status] ?? 'neutral',
                        "data-testid": ids.status,
                        children: r.statusLabel || r.status
                    })
            }
        ]
    });
}
